import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Play, X, VideoOff } from "lucide-react"; // <-- Yahan VideoOff icon add kiya hai
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/motion";
import { FinalCTA } from "../sections/HomeBlocks2";
import { PORTFOLIO } from "../data/content";

const FILTERS = [
  { key: "all", label: "All work" },
  { key: "web", label: "Website Design" },
  { key: "video", label: "Video Ads" },
];

export default function Portfolio() {
  const [filter, setFilter] = useState("all");
  const [active, setActive] = useState(null);
  const items = PORTFOLIO.filter((p) => filter === "all" || p.type === filter);

  return (
    <main>
      <PageHeader
       
        lines={["Work that shows", "our direction."]}
        sub="These are demo concept pieces showing our design and video style. As client projects ship, real case studies will take their place — honestly labeled, always."
      />

      <section className="pb-24" data-testid="portfolio-page">
        <div className="container-x">
          <div className="flex flex-wrap gap-3 mb-12" role="tablist" aria-label="Filter portfolio">
            {FILTERS.map((f) => (
              <button
                key={f.key}
                data-testid={`portfolio-filter-${f.key}`}
                onClick={() => setFilter(f.key)}
                className={`btn text-sm !py-2.5 !px-5 ${filter === f.key ? "btn-primary" : "btn-ghost"}`}
              >
                {f.label}
              </button>
            ))}
          </div>
          <motion.div layout className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <AnimatePresence mode="popLayout">
              {items.map((p, i) => (
                <motion.button
                  key={p.title}
                  layout
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.95 }}
                  transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                  onClick={() => setActive(p)}
                  data-testid={`portfolio-card-${i}`}
                  className="card overflow-hidden text-left p-0 cursor-pointer group"
                >
                  <div className="relative h-56 overflow-hidden">
                    <img src={p.img} alt={`${p.title} — ${p.tag} concept`} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    {p.type === "video" && (
                      <span className="absolute inset-0 flex items-center justify-center">
                        <span className="w-12 h-12 rounded-full bg-[#0B0C1A]/70 backdrop-blur flex items-center justify-center border border-[rgba(255,255,255,0.2)]">
                          <Play size={18} className="text-[#00D9C0] ml-0.5" />
                        </span>
                      </span>
                    )}
                  </div>
                  <div className="p-5">
                    <span className="text-xs font-heading font-semibold tracking-widest uppercase text-[#6C5CE7]">{p.tag}</span>
                    <h3 className="text-[1.05rem] mt-1.5 mb-1 text-[#F5F5FA]">{p.title}</h3>
                    <p className="text-[#A0A3C2] text-sm m-0">{p.desc}</p>
                  </div>
                </motion.button>
              ))}
            </AnimatePresence>
          </motion.div>
          
        </div>
      </section>

      <AnimatePresence>
        {active && (
          <motion.div
            data-testid="portfolio-lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setActive(null)}
            className="fixed inset-0 z-50 bg-[#0B0C1A]/95 backdrop-blur-md flex items-center justify-center p-5"
          >
            <motion.div
              initial={{ scale: 0.92, y: 24 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.92, y: 24 }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              onClick={(e) => e.stopPropagation()}
              className="card max-w-3xl w-full overflow-hidden hover:!transform-none"
            >
              
              {/* YAHAN VIDEO, FALLBACK MESSAGE AUR IMAGE KI LOGIC ADD KI GAYI HAI */}
              {active.type === "video" ? (
                active.videoUrl ? (
                  <video 
                    src={active.videoUrl} 
                    controls 
                    autoPlay 
                    playsInline
                    className="w-full max-h-[60vh] object-cover bg-black"
                  />
                ) : (
                  <div className="w-full h-[40vh] sm:h-[50vh] bg-[#0B0C1A] flex flex-col items-center justify-center p-8 text-center border-b border-[rgba(255,255,255,0.05)]">
                    <VideoOff size={48} className="text-[#A0A3C2]/40 mb-5" />
                    <h4 className="text-[#F5F5FA] text-[1.15rem] font-semibold mb-2">Video Update in Progress</h4>
                    <p className="text-[#A0A3C2] text-sm max-w-sm m-0 leading-relaxed">
                      We are currently optimizing this case study for high-quality playback. Please check back shortly.
                    </p>
                  </div>
                )
              ) : (
                <img src={active.img} alt={active.title} className="w-full max-h-[60vh] object-cover" />
              )}
              {/* ------------------------------------------- */}

              <div className="p-7 flex items-start justify-between gap-6">
                <div>
                  <span className="text-xs font-heading font-semibold tracking-widest uppercase text-[#6C5CE7]">{active.tag}</span>
                  <h3 className="mt-1.5 mb-2">{active.title}</h3>
                  <p className="text-[#A0A3C2] text-sm m-0">{active.desc}</p>
                </div>
                <button data-testid="lightbox-close" onClick={() => setActive(null)} aria-label="Close viewer" className="p-2.5 border border-[rgba(255,255,255,0.15)] rounded-lg text-[#F5F5FA] bg-transparent cursor-pointer shrink-0 transition-colors hover:bg-[rgba(255,255,255,0.05)]">
                  <X size={19} />
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      <FinalCTA />
    </main>
  );
}